import { useEffect } from 'react'
import { useParams } from 'react-router-dom'
import posthog from 'posthog-js'
import Header from 'components/headers/withGreenBack'
import DotsLoading from 'components/loadings/dotsLoading'
import { SectionError } from 'components/states'
import CashboxHeader from 'modules/cashbox/header'
import CashboxActions from 'modules/cashbox/actions'
import CashboxTabs from 'modules/cashbox/tabs'
import { useCashbox } from 'modules/cashbox/hooks'

/**
 * صندوق قرعه‌کشی detail.
 *
 * Until now the funds list rendered cashboxes but tapping one only produced
 * «این صفحه درحال پیاده سازی می باشد» — the product existed on Android and on
 * the boxes payload, and nowhere in the PWA. This is that screen.
 */
export default function CashboxPage() {
    const { id } = useParams()
    const { cashbox, isLoading, isError, refetch } = useCashbox(id)

    useEffect(() => {
        if (cashbox) {
            posthog.capture('cashbox_detail_viewed', {
                cashbox_id: cashbox.id,
                state: cashbox.state,
                role: cashbox.membership?.role,
                plan: cashbox.plan,
            })
        }
    }, [cashbox])

    if (isLoading) return <DotsLoading />

    // Branch on isError, not on `!cashbox` — the funds list spins forever
    // because it does the latter (see modules/funds/index.tsx).
    if (isError || !cashbox)
        return (
            <div className="bg-white min-h-screen">
                <Header title="صندوق قرعه‌کشی" />
                <div className="p-4">
                    <SectionError onRetry={() => refetch()} />
                </div>
            </div>
        )

    return (
        <div className="bg-white min-h-screen">
            <Header title="صندوق قرعه‌کشی" />
            <CashboxHeader cashbox={cashbox} />
            <CashboxActions cashbox={cashbox} />
            <CashboxTabs id={id} cashbox={cashbox} />
        </div>
    )
}
